<script>
import {generateTitle2, getTitleOrDefault} from "@/utils/i18n";

export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const {icon, title, code} = context.props
    const vnodes = []

    if (icon) {
      if (icon.includes('el-icon')) {
        vnodes.push(<i class={[icon, 'sub-el-icon']}/>)
      } else {
        vnodes.push(<svg-menu-icon icon-class={icon}/>)
      }
    }

    if (code) {
      vnodes.push(<span slot='title'>{getTitleOrDefault(code, title)}</span>)
    }
    return vnodes
  }
}
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}

.el-menu svg {
  font-size: 23px;
}
</style>
